<template>
  <div>
    <b-table :data="products" hoverable>
      <b-table-column field="product.xProd" label="Produto" v-slot="props">
        <span class="adjust-top">
          {{ props.row.product.xProd }}
        </span>
      </b-table-column>

      <b-table-column field="product.cEAN" label="EAN" v-slot="props">
        <span class="adjust-top">
          {{ props.row.product.cEAN }}
        </span>
      </b-table-column>

      <b-table-column
        field="product.vProd"
        label="Valor Unitário"
        v-slot="props"
      >
        <span class="adjust-top">
          {{ props.row.product.vProd }}
        </span>
      </b-table-column>

      <template slot="empty">
        <table-empty-template />
      </template>
    </b-table>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";

export default {
  mixins: [common, mask],

  props: ["products"],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {};
  },

  methods: {
    loading(event) {
      this.$emit("is-loading", event);
    }
  },

  computed: {
    ...mapGetters(["preferences"])
  }
};
</script>

<style>
.adjust-top {
  position: relative;
  top: 8px;
}
</style>
